import { useState, useEffect } from 'react';
import { AJAX_URL } from '../../../config/index.js';

const useAuth = () => {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [userStatusLoading, setUserStatusLoading] = useState(true);
  const [userName, setUserName] = useState('');

  // Initial check on mount
  useEffect(() => {
    checkUserAuthentication();
  }, []);

  const checkUserAuthentication = async () => {
    setUserStatusLoading(true);
    try {
      const response = await fetch(`${AJAX_URL}fl_check_user_logged_in`);
      const json = await response.json();
      setIsUserLoggedIn(json.data.isLoggedIn);
      setUserName(json.data.username || '');
    } catch (error) {
      console.error('Auth check failed:', error.message);
    } finally {
      setUserStatusLoading(false);
    }
  };

  const handleUserLoggedIn = (username) => {
    setIsUserLoggedIn(true);
    setUserName(username);
  };

  const handleSignOut = async () => {
    console.log('handleSignOut');
    setUserStatusLoading(true);
    try {
      const response = await fetch(`${AJAX_URL}fl_logout_user`);
      const json = await response.json();
      if (json.success) {
        setIsUserLoggedIn(false);
        setUserName('');
        localStorage.removeItem('jwt');
        localStorage.removeItem('jwtExpiresAt');
      } else {
        throw new Error('Sign out failed');
      }
    } catch (error) {
      console.error('Sign out error:', error.message);
    } finally {
      setUserStatusLoading(false);
    }
  };

  return {
    isUserLoggedIn,
    userStatusLoading,
    userName,
    checkUserAuthentication,
    handleUserLoggedIn,
    handleSignOut
  };
};

export default useAuth;
